import { useEffect, useState } from 'react'

import { RECEIPT_AVAILABILITY_REFRESH_INTERVAL } from '../../constants'
import {
  getReceiptAvailabilityDelayJst,
  isReceiptAvailableJst,
} from '../../utils'

export const useReceiptAvailability = (checkOutDate?: string) => {
  const [checkedAt, setCheckedAt] = useState(Date.now)
  const isReceiptAvailable = isReceiptAvailableJst(checkOutDate)

  useEffect(() => {
    const delay = getReceiptAvailabilityDelayJst(checkOutDate)
    if (isReceiptAvailable || delay === 0) return undefined
    // Daily checks keep distant checkout dates within the browser timer limit.
    const timer = window.setTimeout(
      () => setCheckedAt(Date.now()),
      Math.min(delay, RECEIPT_AVAILABILITY_REFRESH_INTERVAL)
    )
    return () => window.clearTimeout(timer)
  }, [checkOutDate, checkedAt, isReceiptAvailable])

  return { isReceiptAvailable }
}
